module.exports = __webpack_public_path__ + "static/media/tutor-Bimg3.5fd5657d.jpg";